import { AuthService } from '@aipb/auth';
import { inject, Injectable, isDevMode } from '@angular/core';
import { SetupHandler } from './setup.handler';

@Injectable({
  providedIn: 'root'
})
export class SentryBreadcrumbHandler extends SetupHandler {
  auth = inject(AuthService);

  constructor() {
    super('sentry-breadcrumb.handler');
  }

  handle() {
    if (isDevMode()) return;

    this.auth.initSentryBreadcrumb();
    this.addLogMessage('setup auth breadcrumb for Sentry');
  }
}
